import React, { useEffect, useState } from "react";
import { ReactComponent as CloseSVG } from "../../../assets/close.svg";
import { OPDarkContainer, OPBox, OPWrapper } from "../settings/SettingsStyled";
import currencies from "../../helpers/getCurrency";
import {
  TabBox,
  Tab,
  Header,
  Row,
  Exit,
  StatBox,
  Item,
  Title,
  OuterBox,
} from "./HistoryStyled";

export default ({
  handleAbove,
  userId,
  history,
  floorFigure,
  aboveAnim,
  handleSettingsOut,
  handleAboveAnim,
  getBetReply,
  handleNotification,
  handleRoundID,
  audio,
  userInfo,
}) => {
  const { precision } = userInfo;

  const [active, setActive] = useState("my");
  const [closeBtn, setcloseBtn] = useState(false);
  const History = {
    all: history.allHistory,
    my: history.myHistory,
    high: history.highRoller,
  };
  const { my, all, high } = History;
  const [tab, setTab] = useState(my);
  const [soundPlayed, setSoundPlayed] = useState(false);

  const handleActiveTab = (e) => {
    setActive(e);
  };

  useEffect(() => {
    if (active === "high") {
      setTab(high);
    } else if (active === "my") {
      setTab(my);
    } else {
      setTab(all);
    }
  }, [active, all, my, high]);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  const clickHandler = (r, u) => {
    if (userId === u) {
      getBetReply(r);
      handleRoundID(r);
      audio.goForward();
      setSoundPlayed(true);
      handleAbove("betReply");
      handleAboveAnim(true);
    } else {
      setSoundPlayed(false);
      handleNotification("You can only see your bet reply");
    }
  };
  return (
    <OPDarkContainer aboveAnim={aboveAnim}>
      <OPWrapper>
        <OPBox aboveAnim={aboveAnim}>
          <TabBox>
            <OuterBox active={active === "my"}>
              <Tab
                onClick={() => {
                  active !== "my" && audio.tabChange();
                  handleActiveTab("my");
                }}
                active={active === "my"}
              />
              <p>My</p>
            </OuterBox>
            <OuterBox active={active === "all"}>
              <Tab
                onClick={() => {
                  active !== "all" && audio.tabChange();
                  handleActiveTab("all");
                }}
                active={active === "all"}
              />
              <p>All</p>
            </OuterBox>
            <OuterBox active={active === "high"}>
              <Tab
                onClick={() => {
                  active !== "high" && audio.tabChange();
                  handleActiveTab("high");
                }}
                active={active === "high"}
              />
              <p>High</p>
            </OuterBox>
            <Exit
              aboveAnim={aboveAnim}
              close={closeBtn}
              onClick={() => {
                setAnimation(closeBtn, setcloseBtn);
                handleAboveAnim(false);
                audio.goBack();
                setTimeout(() => {
                  handleAbove(false);
                  handleSettingsOut(false);
                }, 150);
              }}
            >
              <CloseSVG />
            </Exit>
          </TabBox>
          <Header precision={precision}>
            <Title>User</Title>
            <Title>Payout</Title>
            <Title>Win Amount</Title>
          </Header>
          <StatBox>
            {tab.map((item, index) => (
              <Row
                soundPlayed={soundPlayed}
                key={index}
                precision={precision}
                cur={userId === item.user_id}
                onClick={() => clickHandler(item.round_id, item.user_id)}
              >
                <Item>{item.user_name}</Item>
                <Item>{floorFigure(item.winCoef, 2)}X</Item>
                <Item
                  win={item.winAmount - item.betAmount > 0}
                  className="profit"
                >
                  <p className="winAmount">{item.winAmount}</p>
                  <p style={{ marginLeft: '2px' }}>
                    {currencies[item.currency]}
                    {item.winAmount - item.betAmount > 0 ? "↑" : "↓"}
                  </p>
                </Item>
              </Row>
            ))}
          </StatBox>
        </OPBox>
      </OPWrapper>
    </OPDarkContainer>
  );
};
